import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { SessionService } from '../services';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

export class TraceSessionInterceptor implements HttpInterceptor {
  private sessionService: SessionService = inject(SessionService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const traceSessionId: HttpRequest<unknown> = req.clone({
      headers: req.headers.set('x-trace-session-id', this.sessionService.getUuid())
    });

    return next.handle(traceSessionId);
  }
}
